import React, { useState, useEffect, useRef } from 'react';
import './FirmSelection.css';
import axios from 'axios';

const FirmSelection = ({ firmeList, onClose, loginDataRef, setParentError }) => {
  const [selectedFirm, setSelectedFirm] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const searchInputRef = useRef(null);
  const redirectStartedRef = useRef(false);


  useEffect(() => {
    // Focus the search input when the component is mounted
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);
  
  const handleFirmSelection = async (firma) => {
    if (isSubmitting) return;

    redirectStartedRef.current = false;
    setIsSubmitting(true);
    setSelectedFirm(firma);

    const { IdKorisnika, GUID } = loginDataRef.current;


  
    const loginData = {
      IdKorisnika,
      GUID,
      IdFirme: firma.Id,
      IdBaze: firma.IdBaze,
    };

    
  const API_URL = process.env.REACT_APP_API_URL;

    try {
        const response = await axios.post(`${API_URL}/Login/Korisnik/LoginUFirmu`, loginData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
       
        if (response.status === 200) {
            const data = response.data; 
            if (data) {
              redirectStartedRef.current = true;
              window.history.replaceState(null, null, '/'); 
              window.location.replace(data); 
            }
        }
    } catch (err) {
        //
        if (err.response?.status === 400) {
          // Axios includes the server response in `err.response`
          console.log('Error response:', err.response);
          setParentError(err.response.data.Message); 
        }
        else {
          setParentError("Došlo je do greške u komunikaciji sa serverom. Pritisnite ctrl i f5 na tastaturi u isto vreme i pokušajte ponovo. ");
          }
      } finally {
        if (!redirectStartedRef.current) {
          setIsSubmitting(false);
        }
      } 

  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && filteredFirms.length > 0 && !isSubmitting) {
      handleFirmSelection(filteredFirms[0]);  // Select the first firm from the filtered list
    }
  };

    // Filter firms based on search term
  const filteredFirms = firmeList.filter(firma =>
        firma.NazivFirme.toLowerCase().includes(searchTerm.toLowerCase())
      );

  return (
    <div className='modal-overlay'>
    <div className="modal-firmselection">
      <div className={`modal-content-firmselection ${isSubmitting ? 'modal-content-firmselection--loading' : ''}`}>
        <div className='modal-content-firmselection-header'>
        <h2>Odaberite firmu</h2>
        <button className="modal-close" onClick={onClose} disabled={isSubmitting}>
            ×
          </button>
        </div>
        <input
          type="text"
          placeholder="Pretraži firmu..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={handleKeyDown}
          className="search-input"
          ref={searchInputRef}
          disabled={isSubmitting}
        />
        <div className="firm-list">
          {filteredFirms.length > 0 ? (
            filteredFirms.map((firma) => (
              <div
                key={`${firma.Id}/${firma.IdBaze}`}
                className={`firm-item ${selectedFirm?.NazivFirme === firma.NazivFirme ? 'selected' : ''}`}
                onClick={() => handleFirmSelection(firma)}
                aria-disabled={isSubmitting}
              >
                {firma.NazivFirme}
              </div>
            ))
          ) : (
            <div>Nemate odabranu firmu </div>
          )}
        </div> 
        {isSubmitting && (
          <div className="firm-loading-overlay" role="status" aria-live="polite">
            <div className="firm-loading-box">
              <span className="firm-spinner" aria-hidden="true" />
              <span>Logovanje u firmu...</span>
            </div>
          </div>
        )}
      </div>
    </div>
    </div>
  );
};

export default FirmSelection;
